import { useQuery } from '@tanstack/react-query';
import { createRepo } from 'lib/api/firebase';
import { Collection } from 'lib/documents';
import { PatientAssessmentOverview } from 'lib/documents/patient-assessment/patient-assessment';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';

const repo = createRepo<PatientAssessmentOverview>([
  Collection.PatientAssessments
]);

export async function getAssessmentOverviewFromFirestore(patientId: string) {
  const data = await repo.find(patientId);
  if (data === undefined) {
    throw new Error(
      `[useGetAssessmentOverview] PatientAssessmentOverview for Patient (id=${patientId}) does not exist.`
    );
  }
  return data;
}

export function useGetAssessmentOverview(patientId: string) {
  return useQuery({
    queryKey: queryKeyFactory.assessment.overview(patientId),
    queryFn: () => getAssessmentOverviewFromFirestore(patientId)
  });
}
